/* This is for ajio.com production */
module.exports = {
  endpoints: {
    category: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/products/category'
    },
    categoryV4: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v4/rilfnl/products/category'
    },
    categoryV6: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v6/rilfnl/products/category'
    },
    categoryV7: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v7/rilfnl/products/category'
    },
    personalisedCategory: {
      href: 'https://island.web.ajio.com/searchservices/v1/rilfnl/personalized/products/category'
    },
    capsulecp: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/capsule'
    },
    capsulenewin: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/capsule/capsuleNewIn'
    },
    topSearches: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/products'
    },
    products: {
      href: 'http://10.131.47.177:8080/aggregator/pdp'
    },
    checkProductServiceability:{
      href: 'http://10.131.47.177:8080/aggregator/pdp/serviceability'
    },
    curatedPage: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/category'
    },
    recommend: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/recommend'
    },
    recommendation: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/recommendation/v1/pairing/products'
    },
    ensamble: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/ensamble'
    },
    recentlyViewed: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/recentlyViewed'
    },
    productdeliverycheck: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/productdeliverycheck'
    },
    capsules: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/capsule/productCapsule'
    },
    search: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/products/search'
    },
    searchV4: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v4/rilfnl/products/search'
    },
    searchV6: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v6/rilfnl/products/search'
    },
    searchV7: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v7/rilfnl/products/search'
    },
    newdesignhomepage: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/newdesignhomepage'
    },
    landingPageRuntime: {
      href: 'http://sf.ajio.ril.com/storefront/cms/page'
    },
    cmsComponent: {
      href: 'http://sf.ajio.ril.com/storefront/cms/component'
    },
    runtimeLocale: {
      href: 'http://sf.ajio.ril.com/storefront/cms/locale'
    },
    runtimeNavigationDesktop: {
      href: 'http://sf.ajio.ril.com/storefront/cms/navigation'
    },
    runtimeNavigationDesktopPreview: {
      href: 'http://cms-editor.ajio.ril.com/cms/v1/navigation/preview'
    },
    landingPageRuntimePreview: {
      href: 'http://cms-editor.ajio.ril.com/cms/v1/page/preview'
    },
    landingPageRuntimeArchive: {
      href: 'http://cms-editor.ajio.ril.com/cms/v1/page/archive'
    },
    newcategoryselection: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/newcategoryselection'
    },
    searchsuggestions: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/products/suggestions'
    },
    navigationdesktop: {
      href: 'https://www.ajio.com/rilfnlwebservices/v2/rilfnl/navigation/all'
    },
    navigationmobile: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/navigation/navnodes'
    },
    myaccount: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/navigation'
    },
    footer: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/footer/navlinks'
    },
    minicart: {
      href: 'https://island.web.ajio.com/cart/rollover/json/MiniCart'
    },
    wishlist: {
      href: 'https://island.web.ajio.com/addToWishlistAjax'
    },
    leaderBoard: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/topshopper'
    },
    accountCheck: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/accountCheck'
    },
    loginToken: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/oauth/token'
    },
    generateLoginOTP: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/login/sendOTP'
    },
    signUpAndSocial: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    signInSocial: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    selfcarefaq: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/selfcare/footer'
    },
    selfcareFaqSearch: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/searchService/FAQ/search'
    },
    selfcareInitChat: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/selfcare/initiateChat'
    },
    setNewPassword: {
      href:
        'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/forgottenpasswordtokens/set/password'
    },
    selfcareOrderDetails: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    getProfile: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/users/current'
    },
    npsFormQuestionsData: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/survey'
    },
    npsFormAnswerSubmit: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/survey/submitsurvey'
    },
    getStoreList: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/SISStore'
    },
    getStoreListCms: {
      href: 'http://sf.ajio.ril.com/storefront/cms/stores'
    },
    getStoreListCmsRevampedPreview: {
      href: 'http://sf.ajio.ril.com/cms-editor/store/preview?platform=MOBILE&tenantId=AJIO'
    },
    sizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/getBrickBrandVendorStyleSizeChart'
    },
    productLevelSizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/productLevelSizeGuide'
    },
    recommendUserSize: {
      href: 'http://sizechart.services.ajio.com/sizechart/recommendUserSize'
    },
    fetchUserSizeGuide: {
      href: 'http://sizechart.services.ajio.com/sizechart/fetchUserSizeGuide'
    },
    kioskIPWhitelist: {
      href: 'https://assets.ajio.com/snoop/kioskIPWhitelist.json'
    },
    roadblock: {
      href:
        'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/roadblockbannercmp?uiel=Mobile&format=json'
    },
    appticker: {
      href:
        'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/appstickybannercmp?uiel=Mobile&format=json'
    },
    submitAssistantId: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/submitEmpId'
    },
    verifyOTP: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/login/verifyOTP'
    },
    generateCreditUsageOTP: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/kiosk/sendOTP'
    },
    signUpKiosk: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/registerKiosk'
    },
    kioskEntryPage: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/kiosklandingpage'
    },
    sessionClear: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    checkDeliveryDetails: {
      href: 'http://10.131.47.177:8080/aggregator/edd/checkDeliveryDetails'
    },
    checkDeliveryDetailsV2: {
      href: 'http://10.131.47.177:8080/aggregator/pdp/scopedView'
    },
    checkServiceableCart: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/users'
    },
    mobileBottomNavList: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/cms/component'
    },
    uploadReturnProductImages: {
      href:
        'https://island.web.ajio.ril.com/rilfnlwebservices/v2/rilfnl/users/USER_EMAIL_ID/returns/uploadReturnimage'
    },
    flashSaleApiUrl: {
      href: 'http://flashsale-internal.services.ajio.com/flashsale'
    },
    flashSaleUrl: {
      href: 'https://flashsale.services.ajio.com/flashsale'
    },
    fetchIfscCodeDetails: {
      href: 'https://payment.services.ajio.com/payment-engine/api/v1/bank/details'
    },
    luxeBrandsList: {
      href:
        'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/catalogs/rilfnlProductCatalog/Online/categories/luxebrands'
    },
    bankOffers: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v2/rilfnl/allActiveBankOffer'
    },
    affiseGetConversions: {
      href: 'https://api-ajios.affise.com/3.0/stats/conversions'
    },
    affiseEditConversions: {
      href: 'https://api-ajios.affise.com/3.0/admin/conversion/edit'
    },
    affisePostback: {
      href: 'https://offers-ajios.affise.com/postback'
    },
    customerTypeUAAS: {
      href: 'http://uaas.ajio.com/uaas/v2/rilfnl/users/CUSTOMER_ID/customertype'
    },
    customerTypeUAASV4: {
      href: 'http://uaas.ajio.com/uaas/v4/rilfnl/users/customertype?service='
    },
    myAccountCMS: {
      href: 'http://sf.ajio.ril.com/storefront/cms/page/static?content=navigation&name=myaccount'
    },
    uaasVerifyPan: {
      href: 'http://uaas.ajio.com/uaas/users/verifyTaxPayerId'
    },
    relevantProductWidget: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/v3/rilfnl/products/category'
    },
    accountDelete: {
      href: 'https://island.web.ajio.com/uaas/users/CUSTOMER_ID/deleteAccount'
    },
    jioAdsSapiApi: {
      href: 'https://mercuryads.jio.com/delivery/sapi.php'
    },
    rushAvailabilityCall: {
      href: 'http://island.web.ajio.com/rilfnlwebservices/v1/deliveryType/availability'
    },
    productDeliveryTypeRush: {
      href: 'http://10.131.47.177:8080/aggregator/pdp/deliveryType'
    },
    deviceLevelCohortV3: {
      href: 'http://gcprepamruntime.services.ajio.jio.com/service/am/runtime/v3/cohort/getUserSegmentAndCohort/device/'
    },
    recommendationWidgetOsmos: {
      href: 'https://island.web.ajio.com/rilfnlwebservices/recommendation/v1/page/data'
    },
    bannerAdsOsmos: {
      href: 'https://ajio-ba.o-s.io/v2/bsda/pt'
    },
    osmosClickTracker: {
      href: 'https://t.o-s.io/aclick/'
    },
    osmosImpressionTracker: {
      href: 'https://t.o-s.io/events?event_name=funnel_impression'
    },
    recommendationTrendsVibes: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/recommendation/v1/trends'
    },
    recommendationEngineCelebration: {
      href: 'https://sf.ajio.ril.com/rilfnlwebservices/recommendation/v1/badges'
    },
    crossSellCartRecommendations: {
      href: 'https://gcprep-search.services.ajio.jio.com/searchservices/v1/cross-sell/recommendations'
    },
    galleriGenerateTokenAPIURL: {
      href: 'http://uaas.ajio.com/uaas/v1/creator-commerce/auth-token'
    }
  },
  properties: {
    version: '01.03.00',
    environment: 'ISLAND',
    siteUrl: 'https://www.ajio.com',
    parentUrl: 'https://www.ajio.com',
    baseImgUrl: 'https://assets-jiocdn.ajio.com',
    assetUrl: 'https://assets-jiocdn.ajio.com',
    imageBaseUrl: 'https://assets-jiocdn.ajio.com',
    apiUrl: 'https://island.web.ajio.com/',
    wishlistUrl: 'http://sf.ajio.ril.com',
    paymentURL: 'https://payment.services.ajio.com',
    luxeURL: 'https://island-luxe.web.ajio.com',
    streetURL: 'https://island-street.web.ajio.com',
    luxeGoogleUrl: 'https://island-luxe.web.ajio.com',
    pAPI: 'https://payment.services.ajio.com',
    npeBaseUrl: 'http://runtime.promoengine.services.ajio.com',
    cemUrl: 'https://www.ajio.com/cem',
    previewCheck: false,
    gtmCode: '5XMX63',
    optimizeID: 'GTM-W6S3W89',
    GAID: 'UA-68002030-1',
    APIErrorGAID: 'UA-68002030-8',
    appAjioText: 'AJIO Online Shopping App',
    appAjioInstallText: 'Use App for a better experience',
    androidAppBaseLink: 'android-app://com.ril.ajio/',
    iosAppBaseLink: 'ios-app://1113425372/',
    fbAppId: '530272470511330',
    googleClientId: '451315316170-qir4dv350qkc1214i1786p0tq184df0m.apps.googleusercontent.com',
    roadBlock: true,
    timeout: 25000,
    timeoutNode: 30000,
    timeoutClient: 40000,
    dataGrinchAppKey: 'app5b30be1f0e5bf814621703f9',
    rumMOKey: 'c58a39eb46bfd43b62704a0ecf8d6fd8',
    pe: 'ON', // "OFF" for turning OFF
    dropAtStore: 'ON',
    dropAtStoreBanner: 'Available only at Trends stores in Bangalore',
    pickFromStore: 'OFF',
    pickFromStoreBanner: 'Available only at Trends stores in Bangalore',
    downloadInvoiceFlag: true,
    gpayAppticker: 'ON', // ON = hide, OFF = show
    gpayRoadBlock: 'ON', // ON = hide, OFF = show
    cleverTapID: '48K-4R4-K84Z',
    sizeSenseConfig: {
      environment: 'prod',
      accessToken: '748f8bcee348ee0cba98587ea1b87e8a34d4eb5fdb17f6138b93ac3166031c8c',
    },
    firebaseConfig: JSON.stringify({
     
    }),
    firebaseConfig_M: JSON.stringify({
    
    }),
    copilotURL: 'https://script.copilot.live/v1/copilot.min.js?tkn=cat-6cvtdddi',
    amplitude_experiment_server_key: 'server-AblRWcufkysyE4w4XxpxB7N8XuL517jZ',
    ajioLoyaltyServiceUrl: 'https://payment.services.ajio.com',
    botifyWebsiteId: 'UO4YE7',
    amplitude_api_key: '9ac8bf1364978b2734f25fe8793278c8',
    fyndConfig: {
      applicationID: '6920511ba88a0b4351d486dc',
      applicationToken: 'IHh6B1LQN',
      fyndApiBaseUrl: 'https://www.ajio.com',
      storeIds: {
        ajio: null,
        luxe: '69cb841a14a7a12382193ebc',
        ajiogram: '69afbc548c950b22d77b20fb',
        rush: '69ce6d49a6a440f230dbd7bb'
      }
    }
  }
};